import { render, staticRenderFns } from "./ProcessTable.vue?vue&type=template&id=d313dffc&"
import script from "./ProcessTable.vue?vue&type=script&lang=js&"
export * from "./ProcessTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VChip,VDataTable,VMenu})
